import { Component, Vue } from "vue-property-decorator";
import { i18n } from "../locales";

@Component({})
export default class AutoPlayValidador extends Vue {
    YOUTU_BE = "https://youtu.be/";
    YOUTUBE_COM = "https://www.youtube.com/watch?v="
    warnigMessage = "";
    setAutoplay(url: string, autoplay: boolean): string {
        if (!url) return null;
        if (!url.toLowerCase().includes("youtu")) {
            return url;
        }
        let newString = url.replace(this.YOUTU_BE, this.YOUTUBE_COM);
        url = newString;
        if (autoplay && url && !url.includes("?autoplay=1")) {
            url = url + "?autoplay=1";
        } else if (!autoplay && url && url.includes("?autoplay=1")) {
            url = url.replace("?autoplay=1", "");
        }
        return url;
    }
    getAutoplay(autoplay, videoUrl): boolean {
        if (videoUrl && videoUrl.includes("?autoplay=1"))
            autoplay = true;
        return autoplay ? true : false;
    }
    checkT(url: string, autoplay: boolean): void {
        if (!url) return;
        if ((autoplay || url.includes("autoplay=1")) && url && url.includes("t=")) {
            this.warnigMessage = i18n.t("notifications.descriptions.autoplayCheckT").toString();
        }
        else this.warnigMessage = "";
    }
}